import { Box, BoxProps, Link } from '@mui/material';

import { StandardDisclaimerContent } from '@arrived/common';
import { Issuer } from '@arrived/models';
import { useGetIssuerQuery } from '@arrived/queries';

interface StandardDisclaimerProps extends BoxProps {
  issuerId: Issuer['id'];
}

const LINK_STYLE = { color: 'primary.main', '&:visited': { color: 'primary.main' } };

export const StandardDisclaimer = ({ issuerId, sx, ...rest }: StandardDisclaimerProps) => {
  const issuerState = useGetIssuerQuery(issuerId);

  return (
    <Box sx={{ columns: { xs: 1, lg: 3 }, ...sx }} {...rest}>
      <StandardDisclaimerContent
        issuerName={issuerState.data?.name}
        LinkElement={({ href, text }) => (
          <Link href={href} sx={LINK_STYLE}>
            {text}
          </Link>
        )}
        lineBreakElement={<br />}
      />
    </Box>
  );
};
